import { appUrls } from "../../config/api-config/appUrls";
import { environment } from "../../config/environments/environment";
import { get, post, put } from "../../config/api-config/callMethods";
import getQueryParams from "../../config/api-config/getQueryParams";
import { Organization } from "../../types/interfaces/OrganzationInfo";

/**
 * To get all country list
 * @returns
 */
export function getAllCountry() {
  const url =
    environment.organizationSettingsApi +
    appUrls.organization.country.countryList;

  return get(url);
}
export function organizationSave(organizationInfo: Organization) {
  const url =
    environment.organizationSettingsApi + appUrls.organization.saveOrganization;

  return post(url, organizationInfo);
}

export function updateOrganizationLogo(data: any) {
  const url =
    environment.organizationSettingsApi +
    appUrls.organization.organizationInfo.updateLogo;

  return put(url, data);
}
export function updateOrganizationName(data: any) {
  const url =
    environment.organizationSettingsApi +
    appUrls.organization.organizationInfo.updateOrgName;

  return put(url, data);
}
export function changeWebsiteVanity(data: any) {
  const url =
    environment.organizationSettingsApi +
    appUrls.organization.organizationInfo.updateVanityWebsite;

  return put(url, data);
}
export function updateOrganizationLocation(data: any) {
  const url =
    environment.organizationSettingsApi +
    appUrls.organization.organizationInfo.updateLocation;

  return put(url, data);
}

export function getSubscription() {
  const url =
    environment.organizationSettingsApi +
    appUrls.organization.organizationInfo.subscription;

  return get(url);
}

export function getCurrentUserPlan() {
  const url = environment.cmBackendUrl + "/"+
    appUrls.organization.organizationInfo.getCurrentUserPlan;
  return get(url);
}

export function getPlans(page = 1, limit = 4) {
  const url = environment.cmBackendUrl + "/"+
    appUrls.organization.organizationInfo.getPlans;
  return get(url);
}

export function getPlanSearchByName(planName: string) {
  const base = environment.cmBackendUrl + "/"+
    appUrls.organization.organizationInfo.getPlanSearchByName;
  const url = base + encodeURIComponent(planName);
  return get(url);
}